import { useState as u, useEffect as l } from "react";
var m = Object.defineProperty,
  f = Object.defineProperties,
  d = Object.getOwnPropertyDescriptors,
  c = Object.getOwnPropertySymbols,
  b = Object.prototype.hasOwnProperty,
  h = Object.prototype.propertyIsEnumerable,
  a = (n, e, t) => e in n ? m(n, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : n[e] = t,
  w = (n, e) => {
    for (var t in e || (e = {})) b.call(e, t) && a(n, t, e[t]);
    if (c) for (var t of c(e)) h.call(e, t) && a(n, t, e[t]);
    return n;
  },
  g = (n, e) => f(n, d(e));
const p = () => {
    if (typeof window == "undefined") return {};
    const n = window.location.href.replace(/\/$/, ""),
      e = encodeURIComponent(n),
      t = encodeURIComponent("https://www.olx.com.br");
    if (e === t) return {
      home: !0
    };
    if (e.startsWith(t)) return {
      search: !0
    };
    const o = encodeURIComponent("https://www2.olx.com.br/desapega"),
      s = encodeURIComponent("https://conta.olx.com.br/chats"),
      r = [{
        path: o,
        name: "announce"
      }, {
        path: s,
        name: "message"
      }].find(_ref => {
        let {
          path: i
        } = _ref;
        return e.includes(i);
      });
    return r ? {
      [r.name]: !0
    } : {};
  },
  v = () => {
    const [n, e] = u({}),
      t = () => {
        e(o => g(w({}, o.account && p()), {
          account: !o.account
        }));
      };
    return l(() => {
      const o = p();
      o && e(o);
    }, []), {
      pageActive: n,
      handleToggleAccount: t
    };
  };
export { v as usePageActive };